import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import Table from "../../common/components/table";
import { tenants } from "../../redux/tenants/action";
import { selectTenantsListItems } from "../../redux/tenants/selector";
import PageLoader from "../../components/PageLoader";
import { generatePin } from "../../redux/auth/actions";
import { router } from "../../redux/router/action";
import storePersist from "../../redux/storePersist";

const Organizations = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [rowData, setRowData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const organizationUnitsIdList = storePersist.get("organizationUnits")?.current;
  // const tenatId = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.TenantId;
  const [launchId, setLaunchId] = useState<any>()
  const [launchLabel, setLaunchLabel] = useState<any>()
  const [baseUrl, setBaseUrl] = useState('');
  // const baseServiceURl: any = process.env.REACT_APP_SERVICEDOMAIN;
  // const basePortalURl: any = process.env.REACT_APP_PORTALDOMAIN;
  const tenantItems = useSelector(selectTenantsListItems)
  const [serviceLaunchId, setServiceLaunchId] = useState<any>()
  const [portalLaunchId, setPortalLaunchId] = useState<any>()
  const [portalLaunchLabel, setPortalLaunchLabel] = useState<any>()
  const [serviceLaunchLabel, setServiceLaunchLabel] = useState<any>()
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        isSortLabel: true,
        sortable: false,
        filter: false,
        headerName: '#',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'Edit', headerName: 'Edit', sortable: false, filter: false, cellRenderer: 'editIconRenderer'
      },
      { field: 'CompanyName', headerName: 'Company Name',searchField: 'CompanyName', sortable: true, filter: true, filterType: 'text' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      {
        field: 'IsCSGAccessEnabledForPortal', headerName: 'CSG Access Enabled For Portal', cellRenderer: 'yesNoRenderer'
      },
      {
        field: 'IsLaunchedToPortal', headerName: 'Login To Portal', isLaunchedPortal: true,
      },
      {
        field: 'IsCSGAccessEnabledForService', headerName: 'CSG Access Enabled For Service', cellRenderer: 'yesNoRenderer'
      },
      { field: 'IsLaunchedToService', headerName: 'Login to Service', isLaunchedService: true },
      { field: 'BusinessChannels', headerName: 'Business Channels', }
    ]);
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const fetchTenants = () => {
    dispatch(tenants.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenants/all-list`,
      entity: 'tenants',
      jsonData: {
        "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchTenants()
  }, [pageData, pageSize])

  useEffect(() => {
    setRowData(tenantItems?.result?.items)
  }, [tenantItems])

  const handleEditClick = () => {
    // router.push(`organization?id=${data.Id}`);
  }

  const handleGeneratePin = async (data: any, channelName: string) => {
    try {
      setIsLoading(true)
      const response = await dispatch(generatePin({
        loginData: {
          Records: [
            {
              Context: {},
              Message: {
                TenantId: data?.Id,
                SalesChannelName: channelName,
                OrganizationUnitId: organizationUnitsIdList?.length > 0 ? organizationUnitsIdList[0].Id : null
              }
            }
          ]
        }
      }))
      if (channelName === 'Portal') {
        setPortalLaunchId(data.Id)
        setPortalLaunchLabel(response?.result)
      } else {
        setServiceLaunchId(data.Id)
        setServiceLaunchLabel(response?.result)
      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
    }
  }

  const handleLaunchedToPortal = async (row: any) => {
    await dispatch(router.setManagementApplication({
      managementApplication: 'Management'
    }))
    await dispatch(router.setIsManagementAuthenticated({
      isManagementAuthenticated: 'false'
    }))
    localStorage.setItem("tenantName", row.CompanyName);
    const tenantName = row.CompanyName;
    const url = `https://${tenantName}.digiit.${process.env.REACT_APP_API_URL}/management/auth/login/pin`;
    window.open(url, '_blank');
  }

  const handleLaunchedToService = async (row: any) => {
    await dispatch(router.setServiceApplication({
      serviceApplication: 'Service'
    }))
    await dispatch(router.setIsServiceAuthenticated({
      isServiceAuthenticated: 'false'
    }))
    localStorage.setItem("tenantName", row.CompanyName);
    const tenantName = row.CompanyName;
    const url = `https://${tenantName}.digiit.${process.env.REACT_APP_API_URL}/service/auth/login/pin`;
    window.open(url, '_blank');
  }

  const handleReloadData = () => {
    fetchTenants()
  }
  const additionButtons: any = [
    
    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "CompanyName",
        FieldText: "CompanyName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } 

    dispatch(tenants.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenants/all-list`,
      entity: 'tenants',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  return (
    <>
      {tenantItems?.isLoading || isLoading ?
        <PageLoader /> :
        rowData && <Table columnData={columnDefs}
          rowData={tenantItems?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize}
          paginationData={tenantItems?.result?.pagination}
          launchId={launchId}
          launchLabel={launchLabel}
          enableFilter={true} 
          onSearch={handleSearch}
          additionButtons={additionButtons}
          portalLaunchId={portalLaunchId}
          handleLaunchedToPortal={handleLaunchedToPortal}
          handleLaunchedToService={handleLaunchedToService}
          serviceLaunchLabel={serviceLaunchLabel}
          portalLaunchLabel={portalLaunchLabel}
          serviceLaunchId={serviceLaunchId}
          onGeneratePin={handleGeneratePin}
          baseUrl={baseUrl}
          headingName="Accounts" />
      }
    </>
  );
};

export default Organizations;


